import React, { useState, useMemo } from 'react';
import { FaCheck, FaSpinner, FaCalendarAlt, FaClock, FaUser, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import API_URL from './config';

const Consultation = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [selectedDay, setSelectedDay] = useState(null);
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [booking, setBooking] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const dates = useMemo(() => {
    const result = [];
    const today = new Date();
    for (let i = 0; i < 14; i++) {
      const d = new Date(today);
      d.setDate(d.getDate() + i);
      if (d.getDay() !== 0) {
        result.push({
          value: d.toISOString().split('T')[0],
          label: d.toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short' })
        });
      }
    }
    return result;
  }, []);

  const selectDay = async (dateStr) => {
    setSelectedDay(dateStr);
    setSelectedSlot(null);
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/lockin/slots-for-date`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ date: dateStr })
      });
      const data = await res.json();
      setSlots(data.success ? data.slots || [] : []);
    } catch (err) {
      setError('Failed to load slots.');
    }
    setLoading(false);
  };

  const confirmBooking = async () => {
    if (!selectedSlot) return;
    if (!name.trim() || !email.trim() || !whatsapp.trim()) {
      setError('Please fill in all fields.');
      return;
    }
    if (!email.includes('@')) {
      setError('Enter a valid email.');
      return;
    }

    setBooking(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/lockin/book`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim().toLowerCase(),
          whatsapp: whatsapp.trim(),
          day: selectedDay,
          slotId: selectedSlot.id,
          start: selectedSlot.start_time,
          end: selectedSlot.end_time
        })
      });
      const data = await res.json();
      if (data.success) {
        setDone(true);
        setBookingDetails({ day: selectedDay, start: selectedSlot.start_time, end: selectedSlot.end_time });
      } else {
        setError(data.error || 'Slot taken. Pick another.');
        selectDay(selectedDay);
      }
    } catch (err) {
      setError('Network error.');
    }
    setBooking(false);
  };

  const fmt = (t) => t?.slice(0, 5);

  const formatDateLong = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-ZA', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  };

  if (done && bookingDetails) {
    return (
      <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' }}>
        <div style={{ textAlign: 'center', maxWidth: '420px' }}>
          <div style={{ fontSize: '64px', marginBottom: '12px' }}>✅</div>
          <h2 style={{ fontSize: '26px', fontWeight: 800, margin: '0 0 6px', color: '#1a1a1a' }}>Booking Saved!</h2>
          <p style={{ color: '#28a745', fontWeight: 600, fontSize: '16px', margin: '0 0 24px' }}>Our team will contact you soon.</p>
          
          <div style={{ background: '#f9fafb', borderRadius: '14px', padding: '20px', textAlign: 'left', marginBottom: '20px', border: '1px solid #e5e7eb' }}>
            <p style={{ margin: '0 0 8px', fontWeight: 700, color: '#1a1a1a', fontSize: '15px' }}>{name}</p>
            <p style={{ margin: '0 0 8px', color: '#666', fontSize: '13px' }}>{email}</p>
            <p style={{ margin: '0 0 12px', color: '#666', fontSize: '13px' }}>{whatsapp}</p>
            <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '12px' }}>
              <p style={{ margin: '0 0 6px', fontWeight: 600, fontSize: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaCalendarAlt style={{ color: '#007bff' }} /> {formatDateLong(bookingDetails.day)}
              </p>
              <p style={{ margin: 0, fontWeight: 600, fontSize: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaClock style={{ color: '#007bff' }} /> {fmt(bookingDetails.start)} - {fmt(bookingDetails.end)}
              </p>
            </div>
          </div>

          <p style={{ color: '#888', fontSize: '13px', margin: 0 }}>You'll receive a WhatsApp message at your scheduled time.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#fff', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' }}>
      <div style={{ maxWidth: '440px', margin: '0 auto', padding: '30px 20px' }}>
        
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <img src="/Skolify-Logo.jpeg" alt="Skolify" style={{ width: '56px', height: '56px', borderRadius: '12px', objectFit: 'contain', marginBottom: '8px' }} />
          <h1 style={{ fontSize: '18px', fontWeight: 700, margin: 0, color: '#1a1a1a' }}>Skolify</h1>
        </div>

        <div style={{ background: '#fff', borderRadius: '20px', padding: '28px 22px', border: '1px solid #e8e8e8', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 800, margin: '0 0 6px', textAlign: 'center' }}>You Paid — Now Book Your Time</h2>
          <p style={{ fontSize: '13px', color: '#888', textAlign: 'center', margin: '0 0 22px' }}>Select your preferred date and time slot below.</p>

          {error && (
            <div style={{ background: '#fff5f5', border: '1px solid #feb2b2', color: '#c53030', padding: '10px 14px', borderRadius: '10px', fontSize: '13px', marginBottom: '16px', textAlign: 'center' }}>
              {error}
            </div>
          )}

          <Input icon={<FaUser />} value={name} onChange={setName} placeholder="Full name" />
          <Input icon={<FaEnvelope />} value={email} onChange={setEmail} placeholder="Email address" type="email" />
          <Input icon={<FaWhatsapp />} value={whatsapp} onChange={setWhatsapp} placeholder="WhatsApp number" type="tel" />

          <p style={{ fontSize: '13px', fontWeight: 600, color: '#555', margin: '0 0 8px' }}>Select a date:</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', marginBottom: '20px' }}>
            {dates.map(d => (
              <button key={d.value} onClick={() => selectDay(d.value)} style={{
                padding: '10px 6px', borderRadius: '10px', border: selectedDay === d.value ? '2px solid #1a1a1a' : '2px solid #e0e0e0',
                background: selectedDay === d.value ? '#1a1a1a' : '#f9f9f9', color: selectedDay === d.value ? '#fff' : '#333',
                cursor: 'pointer', fontFamily: 'inherit', fontSize: '12px', fontWeight: 600, lineHeight: '1.2'
              }}>{d.label}</button>
            ))}
          </div>

          {selectedDay && (
            <>
              <p style={{ fontSize: '13px', fontWeight: 600, color: '#555', margin: '0 0 8px' }}>Select a time for {formatDateLong(selectedDay)}:</p>
              {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}><FaSpinner style={{ animation: 'spin 1s linear infinite', fontSize: '20px', color: '#007bff' }} /></div>
              ) : slots.length === 0 ? (
                <p style={{ color: '#999', fontSize: '13px', textAlign: 'center', padding: '16px' }}>No slots available for this date.</p>
              ) : (
                <>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
                    {slots.map(s => (
                      <button key={s.id} onClick={() => setSelectedSlot(s)} style={{
                        padding: '13px', borderRadius: '10px',
                        border: selectedSlot?.id === s.id ? '2px solid #007bff' : '2px solid #e0e0e0',
                        background: selectedSlot?.id === s.id ? '#e8f0fe' : '#f9f9f9',
                        cursor: 'pointer', fontFamily: 'inherit', fontSize: '14px', fontWeight: 600,
                        color: selectedSlot?.id === s.id ? '#007bff' : '#333',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                      }}>
                        <FaClock style={{ fontSize: '12px' }} />{fmt(s.start_time)} - {fmt(s.end_time)}
                      </button>
                    ))}
                  </div>

                  <button onClick={confirmBooking} disabled={!selectedSlot || booking} style={{
                    width: '100%', padding: '15px', background: selectedSlot && !booking ? '#1a1a1a' : '#ccc',
                    color: 'white', border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: 700,
                    cursor: selectedSlot && !booking ? 'pointer' : 'not-allowed',
                    fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                  }}>
                    {booking ? <><FaSpinner style={{ animation: 'spin 1s linear infinite' }} /> Booking...</> : <><FaCheck /> Confirm Booking</>}
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const Input = ({ icon, value, onChange, placeholder, type = 'text' }) => (
  <div style={{ position: 'relative', marginBottom: '12px' }}>
    <span style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#999', fontSize: '15px' }}>{icon}</span>
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={{ width: '100%', padding: '13px 13px 13px 42px', border: '2px solid #e8e8e8', borderRadius: '12px', fontSize: '14px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
    />
  </div>
);

export default Consultation;